// extracted by mini-css-extract-plugin
export var circle = "_fw-1";
export var exitConfirmationModal = "_fw-5";
export var iframe = "_fw-0";
export var offline = "_fw-3";
export var online = "_fw-2";
export var workstationSelectError = "_fw-4";